import React, { useRef, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Camera, Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export default function PhotoUploader({ photos = [], onChange, testid }) {
  const camRef = useRef(null);
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    let cur = [...photos];
    try {
      for (const f of Array.from(files)) {
        const fd = new FormData();
        fd.append("file", f);
        const rec = await api.upload(fd);
        cur = [...cur, { id: rec.id, storage_path: rec.storage_path }];
        onChange(cur);
      }
      toast.success("Photo added");
    } catch {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
      if (camRef.current) camRef.current.value = "";
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const remove = (i) => onChange(photos.filter((_, idx) => idx !== i));

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <input ref={camRef} type="file" accept="image/*" capture="environment" hidden onChange={(e) => handle(e.target.files)} />
        <input ref={fileRef} type="file" accept="image/*" multiple hidden onChange={(e) => handle(e.target.files)} />
        <Button type="button" data-testid={testid ? `${testid}-cam` : undefined} onClick={() => camRef.current?.click()} disabled={busy} variant="outline" size="sm" className="gap-1.5 tap-scale">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Camera className="h-4 w-4" />} Photo
        </Button>
        <Button type="button" data-testid={testid ? `${testid}-upload` : undefined} onClick={() => fileRef.current?.click()} disabled={busy} variant="outline" size="sm" className="gap-1.5 tap-scale">
          <Upload className="h-4 w-4" /> Upload
        </Button>
      </div>
      {photos.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {photos.map((p, i) => (
            <div key={p.id || i} className="relative h-16 w-16 overflow-hidden rounded-md border border-border">
              <img src={fileUrl(p.storage_path)} alt="" className="h-full w-full object-cover" />
              <button type="button" onClick={() => remove(i)} className="absolute right-0 top-0 bg-black/60 p-0.5 text-white"><X className="h-3 w-3" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
